// extracted by mini-css-extract-plugin
export default {"permission":"RolePermissionsTab_permission__+kKQ5"};